import { usePage } from '@inertiajs/react';
import { useEffect, useRef } from 'react';
import { useToast } from '../Toast';
const flashMap = {
  notice: 'success',
  success: 'success',
  alert: 'error',
  error: 'error',
};
export function useFlash() {
  const { props } = usePage();
  const { addToast } = useToast();
  const shownRef = useRef(null);
  useEffect(() => {
    const flash = props.flash;
    if (!flash) return;
    const entries = Object.entries(flash).filter(([, msg]) => msg && msg.length > 0);
    if (entries.length === 0) return;

    // Build a fingerprint to avoid re-showing the same flash
    const fingerprint = entries.map(([k, v]) => `${k}:${v}`).join('|');
    if (shownRef.current === fingerprint) return;
    shownRef.current = fingerprint;
    for (const [key, message] of entries) {
      if (!message) continue;
      addToast({
        variant: flashMap[key] ?? 'info',
        message,
      });
    }
  }, [props.flash, addToast]);
}
